import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://backend-xi-liard-33.vercel.app/api',
});

export default instance;
